export default "__VITE_PUBLIC_ASSET__87d7ec45__"